import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { TwitterIcon, FacebookIcon, InstapaperIcon, LinkedinIcon, EmailIcon } from "react-share";
 
import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter } from 'reactstrap';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../../constant';
import Slider from "react-slick";
import Head from './head';
import Foot from './foot';
import { GOOGLE_CAPTCHA_SITE_KEY, BASEURL, IMGBASEURL } from '../../../constant.js';
import jQuery from 'jquery';
import { makeMessageRead, getExclPtnrsEntry, submitEntry, 
  getExclPtnrsEntryB2B,
         uploadImage, 
         uploadBrochureNew,
         uploadBanner, 
         uploadBannerB2b,
         uploadThumbNew,
         saveEntry, 
         uploadLogo, 
         uploadBrochure, 
         uploadGallery,
         uploadThumb2,
         uploadThumb1,
         uploadFile2,
         uploadFile1,
         uploadVideo
          } from './../../../API/FetchCall';
import Cookies from 'universal-cookie';

//import { Editor } from '@tinymce/tinymce-react';
import previewfooter from '../../../../src/assets/images/footerpreview.png';
import previewheader from '../../../../src/assets/images/previewheader.png';

import pdficon from "../../../../src/assets/images/icons/fileicons/pdf.png";
import docicon from "../../../../src/assets/images/icons/fileicons/word.png";
import xlsicon from "../../../../src/assets/images/icons/fileicons/xls.png";

import headerimage from '../../../../src/assets/images/headerimage.png';
import leftmenuimage from '../../../../src/assets/images/leftmenuimage.png';
import rightmenuimage from '../../../../src/assets/images/rightmenuimage.png';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

class exclusivePartnerEdit extends Component {



  constructor(props) {
    const cookies = new Cookies();
    super(props);
    this.state = {
      thumbpreview : false,
      detailedpreview:false,
      submitted:false,
      selectedFile: null,
      banner:'',
      brochure:'',
      brochures:'',
      gallery:'',
      offerimage1:'',
      offerimage2:'',
      offerimage3:'',
      offer1desc:'',
      offer2desc:'',
      contact_number:'',
      offer3desc:'',
      optiontoshow:'onlypartners',
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 99,
      videos:'',
      logo:'defaultlogo.png',
      id:this.props.match.params.id ? this.props.match.params.id : ''
    }

    this.submission = this.submission.bind(this);
    this.onFileUploadBanner = this.onFileUploadBanner.bind(this);
    this.onFileUploadBrochure = this.onFileUploadBrochure.bind(this);
    this.onFileUploadGallery = this.onFileUploadGallery.bind(this);
    this.onFileVideoUpload = this.onFileVideoUpload.bind(this);
    
    this.handleChangeDescription = this.handleChangeDescription.bind(this);
    this.handleChangeoffer1desc = this.handleChangeoffer1desc.bind(this);
    this.handleChangeoffer2desc = this.handleChangeoffer2desc.bind(this);
    
    this.onFileUploadBrochureThumb1 = this.onFileUploadBrochureThumb1.bind(this);
    this.onFileUploadBrochureThumb2 = this.onFileUploadBrochureThumb2.bind(this);

    this.onFileUploadBrochure1 = this.onFileUploadBrochure1.bind(this);
    this.onFileUploadBrochure2 = this.onFileUploadBrochure2.bind(this);
    
    this.id = this.props.match.params.id ? this.props.match.params.id : '';
}

componentDidMount() {

    const { user_data } = this.state;
    if(this.id!='')
      this.getEntry(this.id);
    
}

makeMessageRead = (login_id) => {
    let req = JSON.stringify({
      login_id: login_id
    })
    makeMessageRead(req).then(res => {
      if (res.status === 1) {
          this.setState({notes_seen:true});
      }
    }); 

}

getEntry = (id) => {
    
    let req = JSON.stringify({
      id: id
    })
    getExclPtnrsEntryB2B(req).then(res => {
      if (res.status === 1) {
        this.setState({
          name: res.result.name,
          logo:(res.result.logo!=null)?res.result.logo:this.state.logo,
          banner:(res.result.banners!=null)?res.result.banners:'',
          gallery:(res.result.gallery!=null)?res.result.gallery:'',
          brochure:(res.result.brochure!=null)?res.result.brochure:'',
          brochures:(res.result.brochure!=null)?res.result.brochure:'',
          videos:(res.result.videos!=null)?res.result.videos:'',
          approved:res.result.approved,
          created_date:res.result.created_date,
          facebook:res.result.facebook,
          twitter:res.result.twitter,
          instagram:res.result.instagram,
          linkedin:res.result.linkedin,
          emailaddress:res.result.emailaddress,
          contact_number:res.result.contact_number,
          website:res.result.website,
          address:res.result.address,
          description:(res.result.description!=null)?res.result.description:'',
          promotion_link:res.result.promotion_link,
          promotion_image:(res.result.promotion_image!=null)?res.result.promotion_image:'',
          contenttype:res.result.contenttype,
          link:res.result.link,
          clicktext:res.result.clicktext,
          offerimage1:(res.result.offerimage1!=null)?res.result.offerimage1:'',
          offerimage2:(res.result.offerimage2!=null)?res.result.offerimage2:'',
          offerimage3:(res.result.offerimage3!=null)?res.result.offerimage3:'',
          offer1desc:res.result.offer1desc,
          offer2desc:res.result.offer2desc,
          offer3desc:res.result.offer3desc,
          optiontoshow:res.result.optiontoshow,
          notes_webmaster:res.result.notes_webmaster,
          notes_timesent:res.result.notes_timesent,
          notes_seen:res.result.notes_seen,
          description_b2b:res.result.description_b2b,
          banners_b2b:(res.result.banners_b2b!=null)?res.result.banners_b2b:'',
          offerimage_b2b:res.result.offerimage_b2b,
          offerdesc_b2b:res.result.offerdesc_b2b,
          brochures_b2b:res.result.brochures_b2b,
          contact_number_b2b:res.result.contact_number_b2b,
          emailaddress_b2b:res.result.emailaddress_b2b
        
        })
       
      }else{
        this.setState({isreco:false});
      }
    })
}

cancelPop1 = () => {
this.setState({
  thumbpreview: false
})
}
cancelPop2 = () => {
this.setState({
  detailedpreview: false
})
}

handleChange = (e) => {
  const propName = e.target.name;
  this.setState({ [e.target.name]: e.target.value });
};

handleChangeDescription(value, editor) {
    //console.log(value);
    this.setState({
      description: value
    });
}

handleChangeoffer1desc(value, editor) {
    //console.log(value);
    this.setState({
      offer1desc: value
    });
}

handleChangeoffer2desc (value, editor) {
    //console.log(value);
    this.setState({
      offer2desc: value
    });
}


onFileChange = event => {

  // Update the state
  this.setState({ selectedFile: event.target.files[0] });

};

handleFileSinglePdf1 = event => {

  // Update the state
  this.setState({ brochure1: event.target.files[0] });

};
handleFileSingleThumb1 = event => {

  // Update the state
  this.setState({ thumb1: event.target.files[0] });

};
handleFileSingleThumb2 = event => {

  // Update the state
  this.setState({ thumb2: event.target.files[0] });

};

handleFileSinglePdf2 = event => {

  // Update the state
  this.setState({ brochure2: event.target.files[0] });

};


onMultipleFileChange = event => {

  // Update the state
  this.setState({ selectedFiles: event.target.files});

};


handleFileMultiplePdfs = (e) => {
  const propName = e.target.name;
  var files = e.target.files;

  if (files.length > 3) {
    files = '';
    let toastr = window.toastr.error; //warning
    toastr('', 'Select 5 Pdfs Only', {
      positionClass: "toast-bottom-right",
      containerId: "toast-bottom-right"
    });
  }
  this.setState({
    [propName]: files
  });
};
handleFileMultipleGallery = (e) => {
  const propName = e.target.name;
  var files = e.target.files;
  
  this.setState({
    gallery: files
  });
};
handleFileMultiple = (e) => {
  const propName = e.target.name;
  var files = e.target.files;
  
  if (files.length > 3) {
    files = '';
    let toastr = window.toastr.error; //warning
    toastr('', 'Select 3 Images Only', {
      positionClass: "toast-bottom-right",
      containerId: "toast-bottom-right"
    });
  }
  this.setState({
    banner: files
  });
};

onFileVideoUpload = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('videos', this.state.selectedFile);
  formData.append('id', this.state.id);

  uploadVideo(formData).then((response) => {
   
      if(response.status==1){


        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Video is saved successfully');
       
      }else{

        NotificationManager.error('There is an issue uploading file');
        
      }

  });
  
};


onFileUploadImage = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('image', this.state.selectedFile);
  formData.append('id', this.state.id);

  uploadImage(formData).then((response) => {
   
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Image is saved successfully');
        

      }else{
        
        NotificationManager.error('There is an issue uploading file');

      }

  });
  
};


onFileUploadImage1 = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('image', this.state.selectedFile);
  formData.append('whichoffer', 'offerimage1');
  formData.append('id', this.state.id);

  uploadImage(formData).then((response) => {
   
      if(response.status==1){


        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Image saved successfully');

      }else{

        NotificationManager.error('There is an issue uploading file');
        
      }

  });
  
};

onFileUploadImage2 = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('image', this.state.selectedFile);
  formData.append('whichoffer', 'offerimage2');
  formData.append('id', this.state.id);

  uploadImage(formData).then((response) => {
   
      if(response.status==1){


        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Image saved successfully');

      }else{
        
        NotificationManager.error('There is an issue uploading file');

      }

  });
  
};

onFileUploadImage3 = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('image', this.state.selectedFile);
  formData.append('whichoffer', 'offerimage3');
  formData.append('id', this.state.id);

  uploadImage(formData).then((response) => {
   
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }        

        NotificationManager.success('Image 3 saved successfully');

      }else{
         
        NotificationManager.error('There is an issue uploading file');

      }

  });
  
};

onFileUploadLogo = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('logo', this.state.selectedFile);
  formData.append('id', this.state.id);
  
  
  uploadLogo(formData).then((response) => {
   
      if(response.status==1){


                if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Logo saved successfully');

        this.setState({logo:response.file});

      }else{
         
        NotificationManager.error('There is an issue uploading file');

      }

  });
  
};

onFileUploadBanner = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();
  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('id', this.state.id);
  const banner_data = this.state.banner;

  if(this.state.optiontoshow=='onlypartners'){

    for (let i = 0; i < banner_data.length; i++) {
      formData.append('banners_b2b', banner_data[i]);
    }
  
    uploadBannerB2b(formData).then((response) => {
      
        if(response.status==1){
  
          NotificationManager.success('File is saved successfully');
          //alert(response.files);
          this.setState({banners_b2b:response.files});
  
        }else{
         
          NotificationManager.error('There is an issue');
  
        }
  
      
    });


  }else{

    for (let i = 0; i < banner_data.length; i++) {
      formData.append('banner', banner_data[i]);
    }
  
    uploadBanner(formData).then((response) => {
      
        if(response.status==1){
  
          if(response.id!=''){
            this.setState({id:response.id});
          }
          NotificationManager.success('Banner saved successfully');
          this.setState({banner:response.files});
  
        }else{
          
          NotificationManager.error('There is an issue uploading file');
  
        }
  
      
    });


  }
  

};


onFileUploadGallery = (event) => {

  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();
  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('id', this.state.id);

  const gallery_data = this.state.gallery;

  for (let i = 0; i < gallery_data.length; i++) {
    formData.append('gallery', gallery_data[i]);
  }

  uploadGallery(formData).then((response) => {
    
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }
        NotificationManager.success('Image saved successfully');
        //alert(response.files);
        this.setState({gallery:response.files});

      }else{
        
        NotificationManager.error('There is an issue uploading file');

      }

    
  });
};

onFileUploadBrochureThumb = (event) => {
  
  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('thumb2', this.state.selectedFile);
  formData.append('id', this.state.id);
  formData.append('mode', this.state.optiontoshow);
  
  uploadThumbNew(formData).then((response) => {
   
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Brochure thumbnail is saved successfully');

        this.setState({thumb1:response.file});

      }else{

        NotificationManager.error('There is an issue uploading file');

      }

  });

}; 

onFileUploadBrochureThumb2 = (event) => {
  
  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('thumb2', this.state.selectedFile);
  formData.append('id', this.state.id);
  
  uploadThumb2(formData).then((response) => {
   
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Brochure saved successfully');

        this.setState({thumb1:response.file});

      }else{

        NotificationManager.error('There is an issue uploading file');

      }

  });

}; 
onFileUploadBrochureThumb1 = (event) => {
  
  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('thumb1', this.state.selectedFile);
  formData.append('id', this.state.id);
  
  uploadThumb1(formData).then((response) => {
   
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }
        NotificationManager.success('Brochure Thumb saved successfully');

        this.setState({thumb1:response.file});

      }else{

        NotificationManager.error('There is an issue uploading file');

      }

  });

};    

onFileUploadBrochure2 = (event) => {
  
  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('file2', this.state.selectedFile);
  formData.append('id', this.state.id);
  
  
  uploadFile2(formData).then((response) => {
   
      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Brochure 2 saved successfully');

        this.setState({file1:response.file});

      }else{
         
        NotificationManager.error('There is an issue uploading file');

      }

  });

};

onFileUploadBrochure1 = (event) => {
  
  let toastr = '';
  // Details of the uploaded file
  const { user_type, login_id } = this.state.user_data;
  const formData = new FormData();

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('file1', this.state.selectedFile);
  formData.append('id', this.state.id);
  formData.append('mode', this.state.optiontoshow);
  
  uploadFile1(formData).then((response) => {
   
      if(response.status==1){


        if(response.id!=''){
          this.setState({id:response.id});
        }
        NotificationManager.success('Brochure 1 saved successfully');

        this.setState({file1:response.file});

      }else{
        
        NotificationManager.error('There is an issue uploading file');

      }

  });

};

onFileUploadBrochure = (event) => {
  
  let toastr = '';
  // Details of the uploaded file

  const formData = new FormData();
  const { user_type, login_id } = this.state.user_data;

  formData.append('user_type', user_type);
  formData.append('login_id', login_id);
  formData.append('id', this.state.id);
  formData.append('mode', this.state.optiontoshow);
  formData.append('brochure', this.state.selectedFile);

  uploadBrochureNew(formData).then((response) => {

      if(response.status==1){

        if(response.id!=''){
          this.setState({id:response.id});
        }

        NotificationManager.success('Brochure saved successfully');

      }else{
        
        NotificationManager.error('There is an issue uploading file');

      }
    
  });
};

savefornow(){

    let toastr = '';

    const { user_type, login_id } = this.state.user_data;

    /*
    let downloable_content={
                        contenttype:this.state.contenttype,
                        clicktext:this.state.clicktext,
                        link:this.state.link};
    */

    let req = JSON.stringify({
        id:this.id,
        user_type: user_type,
        login_id: login_id,
        name: this.state.name,
        description:this.state.description,
        website:this.state.website,
        contact_number:this.state.contact_number,
        address:this.state.address,
        emailaddress:this.state.emailaddress,
        facebook:this.state.facebook,
        clicktext:this.state.clicktext,
        link:this.state.link,
        offer2desc:this.state.offer2desc,
        offer1desc:this.state.offer1desc,
        optiontoshow:this.state.optiontoshow,
        contenttype:this.state.contenttype,
        promotion_link:this.state.promotion_link,
        twitter:this.state.twitter,
        instagram:this.state.instagram,
        linkedin:this.state.linkedin,
        approved:0
    })

    saveEntry(req).then((response) => {

        if(response.status==1){

          NotificationManager.success('saved successfully');

        }else{
          
          NotificationManager.error('There is an issue uploading file');
        }
      
    });

}

submission(){
    
  let toastr = '';
   console.log("logo",this.state.logo);
   console.log("banner",this.state.banner);
   console.log("name", this.state.name);
   console.log("desc", this.state.description);

   if(this.state.logo=='' || this.state.logo=='defaultlogo.png' || this.state.banner=='' || this.state.name=='' || this.state.description==''){

    NotificationManager.error('Please make sure you provide all required minimum data such as logo, banner , name and description');


  }else{
    
  const { user_type, login_id } = this.state.user_data;

  let req = JSON.stringify({
      id:this.id,
      user_type: user_type,
      login_id: login_id,
      name: this.state.name,
      description:this.state.description,
      website:this.state.website,
      address:this.state.address,
      emailaddress:this.state.emailaddress,
      contact_number:this.state.contact_number,
      facebook:this.state.facebook,
      clicktext:this.state.clicktext,
      link:this.state.link,
      offer2desc:this.state.offer2desc,
      offer1desc:this.state.offer1desc,
      optiontoshow:this.state.optiontoshow,
      contenttype:this.state.contenttype,
      promotion_link:this.state.promotion_link,
      twitter:this.state.twitter,
      instagram:this.state.instagram,
      linkedin:this.state.linkedin
  })


  submitEntry(req).then((response) => {

      if(response.status==1){

        NotificationManager.success('submitted successfully');

        this.setState({submitted:true});

      }else{
        
        NotificationManager.error('There is an issue uploading file');

      }
    
  });
  }
}

showthumbnail(){
    this.setState({ thumbpreview: true});
}

showdetailed(){
    this.setState({ detailedpreview: true});
}



render() {

    const gallerysettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };


    const banners = (this.state.banner!='')?this.state.banner.toString().split(","):'';
    const gallery = this.state.gallery.toString().split(",");
    const sliders = '';
    //const sliders = this.state.banner.split(",");
    const galleries =   (this.state.gallery!='')?this.state.gallery.toString().split(","):'';
    //const IMG_URL = 'http://localhost:5005/';

    const offer1 = (this.state.offerimage1!='')? IMGBASEURL+'uploads/'+this.state.offerimage1:'';
    const offer2 = (this.state.offerimage2!='')? IMGBASEURL+'uploads/'+this.state.offerimage2:'';
    const offer3 = (this.state.offerimage3!='')? IMGBASEURL+'uploads/'+this.state.offerimage3:'';

    const offer1desc = this.state.offer1desc;
    const offer2desc = this.state.offer2desc;
    const offer3desc = this.state.offer3desc;

    const brochures = this.state.brochures.split(",");

          return (
           <React.Fragment>
                <AdminLayout>
                    
                <div class="col-lg-12 grid-margin stretch-card">
                
                <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Exclusive Partnerships - B2B Content - Management</h4>
                 
 
                  <div class="row">
                      
                      <div class="col-lg-12">


                    <div className="main-content col-md-12 col-xs-12">
   
                                    { this.state.submitted ==true && (
                                    <div class="aftersubmitmessage">
                                      Partnership update has now been resubmitted for review @ BeWise. Thank you for your partnership and we remain greatful.
                                    </div>   
                                    )}
                                    { this.state.submitted ==false && 
 <React.Fragment>  

  <div class="row">
    <div class="col-md-6 col-sm-6 col-xs-12">
      <div class="card">
      <div class="card-body">
        <div class="card-title">
          
           Profile Information 
        </div>
        
          <div class="input-group input-group-sm">
              <input type="text" name="name" class="form-control input-sm" placeholder="Name" value={this.state.name} onChange={this.handleChange} />
          </div>
          <br />
          <div class="input-group input-group-sm">
              <input type="text" name="address" class="form-control input-lg" placeholder="Address" onChange={this.handleChange} value={this.state.address}/>
          </div>
          <br />
          <div class="input-group input-group-sm">
              <input type="email" name="emailaddress" class="form-control input-sm" placeholder="Email Address" onChange={this.handleChange} value={this.state.emailaddress}/>
          </div>
          <br />
          <div class="input-group input-group-sm">
              <input type="text" name="website" class="form-control input-sm" placeholder="Web Site" onChange={this.handleChange} value={this.state.website}/>
          </div>
          <br />
          <div class="input-group input-group-sm">
              <input type="text" name="contact_number" class="form-control input-sm" placeholder="Contact Number" onChange={this.handleChange} value={this.state.contact_number}/>
          </div>
          <br />

          <div class="card-title">
            Description
          </div>

          <div class="input-group">
          <Editor
                            onEditorChange={this.handleChangeDescription}
                            value={this.state.description}
                            apiKey={TINY_EDITOR}
                            init={{
                              height: 300,
                              plugins: [
                                'lists link image paste'
                              ],
                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                            }}
          />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Medias</div>
        
         
          <div class=" input-group-sm">
              <label for="logo">Logo (png)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="logo" class="form-control input-sm" placeholder="Logo" onChange={this.onFileChange}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadLogo}>
                  Upload!
              </button></div>
              </div>
              {this.state.logo!='' && (
              <div class="existingmedia">
                  <img src={IMGBASEURL+"uploads/"+this.state.logo} />
              </div>
              )}
          </div>
          <br />
          <div class="input-group-sm">
              <label for="banner">Brand Banner (980x1028)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" id="banner" name="banner" multiple class="form-control input-sm" placeholder="Banner" onChange={this.handleFileMultiple}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadBanner}>
                  Upload!
              </button></div>
              </div>
              {this.state.optiontoshow=='onlypartners' && this.state.banners_b2b!='' && (
              <div class="existingmedia">
                 <div class="bimage"><img src={IMGBASEURL+"uploads/"+this.state.banners_b2b} /></div>
              </div>
              )}

              {this.state.optiontoshow!='onlypartners' && this.state.banner!='' && (
              <div class="existingmedia">
                 <div class="bimage"><img src={IMGBASEURL+"uploads/"+this.state.banner} /></div>
              </div>
              )}
          </div>
          <br />
          

          <div class=" input-group-sm">
              <label for="video">Video (.mp4)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="video" class="form-control input-sm" placeholder="Video" onChange={this.onFileChange}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileVideoUpload}>
                  Upload!
              </button></div>
              </div>
              {this.state.videos!='' && (
                <div class="existingmedia">
                        <video width="320" height="240" controls>
                        <source src={IMGBASEURL+"uploads/"+this.state.videos} type="video/mp4" />
                        </video>
                </div>
              )}
          </div>
          <br />
       
        </div>
      </div>
       <div class="card ">
        <div class="card-body">
           
          <div class="card-title">Sample Brochure or Magazine in pdf</div>
        

          <div class="borderedrow">
            <div class="input-group-sm">
              <label for="brochure">File (pdf)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="brochure" id="brochure1"  class="form-control input-sm" placeholder="Brochure" onChange={this.onFileChange}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadBrochure}>
                  Upload!
              </button></div>
              </div>
             
            </div>
            <div class=" input-group-sm">
              <label for="brochure">Thumbnail (jpg or png)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="thumb1" id="thumb1"  class="form-control input-sm" placeholder="Thumbnail" onChange={this.onFileChange}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadBrochureThumb}>
                  Upload!
              </button></div>
              </div>
              
            </div>
            </div>

            

        </div>
    </div>
    </div>


  </div>            

  <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Customer Downloads</div>
        
          <div class="row">
            <div class="col-lg-12 col-sm-12">

                <label class="radio-inline">
                <input class="form-check-input" type="radio"  name="contenttype" id="contenttype1" checked={this.state.contenttype === "btn"}  value="btn" onChange={this.handleChange}/> Button
                </label>

                <label class="radio-inline">
                <input class="form-check-input" type="radio" checked={this.state.contenttype === "href"}  name="contenttype" id="contenttype2" value="href" onChange={this.handleChange}/> Hyperlink
                </label>
                           
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-12">
              <div class=" input-group-sm">
              <label for="brochure">Click Text</label>
              <input type="text" name="clicktext" class="form-control input-sm" value={this.state.clicktext} onChange={this.handleChange}/>
              </div>
            </div>
            <div class="col-lg-8 col-sm-12">
              
              <div class="input-group-sm">
                <label for="brochure">Link (an HTTP url that is available to download any resources)</label>
                <input type="text" name="link" class="form-control input-sm" value={this.state.link} onChange={this.handleChange}/>
              </div>
            </div>
          </div>
      
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Exclusive Offers</div>
          <div class="row">
            <div class="col-lg-6 col-sm-12">

              <div class="input-group input-group-sm">
              <label for="brochure">Image 1(.jpg, .gif and .png)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="offerimage1" class="form-control input-sm" placeholder="Image" onChange={this.onFileChange}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadImage1}>
                  Upload!
              </button></div>
              </div>
              {this.state.offerimage1!='' && (
              <div class="existingmedia">
                  <img src={IMGBASEURL+"uploads/"+this.state.offerimage1} />
              </div>
              )}
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12"> 
                  <label for="brochure">Description</label>
                  <Editor
                        onEditorChange={this.handleChangeoffer1desc}
                        value={this.state.offer1desc}
                        apiKey={TINY_EDITOR}
                        init={{
                          height: 400,
                          plugins: [
                            'lists link image paste'
                          ],
                          toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                        }}
                    />

                  </div>
              </div>
              </div>
            </div>

            <div class="col-lg-6 col-sm-12">

              <div class="input-group input-group-sm">
              <label for="brochure">Image 2(.jpg, .gif and .png)</label>
              <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="offerimage2" class="form-control input-sm" placeholder="Image" onChange={this.onFileChange}/></div>
              <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadImage2}>
                  Upload!
              </button></div>
              </div>
              {this.state.offerimage2!='' && (
              <div class="existingmedia">
                  <img src={IMGBASEURL+"uploads/"+this.state.offerimage2} />
              </div>
              )}
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12"> 
                   <label for="brochure">Description</label>

                   <Editor
                        onEditorChange={this.handleChangeoffer2desc}
                        value={this.state.offer2desc}
                        apiKey={TINY_EDITOR}
                        init={{
                          height: 400,
                          plugins: [
                            'lists link image paste'
                          ],
                          toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                        }}
                    />
                </div>
              </div>
              </div>
            </div>

          </div>
      
        </div>


      </div>
    </div>
  </div>

    <div class="row">
    <div class="col-md-6 col-sm-6 col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Embedded Content (html code or script)</div>
          <div class="row">
            <div class="col-lg-12 col-sm-12">

                <div class="input-group">
                    <textarea name="embedded" class="form-control" placeholder="Embedded" rows="8"></textarea>
                </div>
                           
            </div>
          </div>
         
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Social Media</div>
          <div class="input-group input-group-sm">
              <input type="text" name="facebook" class="form-control input-sm" placeholder="Facebook" value={this.state.facebook} onChange={this.handleChange}/>
          </div>
          <br />
          
          <div class="input-group input-group-sm">
              <input type="text" name="instagram" class="form-control input-sm" placeholder="Instagram" value={this.state.instagram} onChange={this.handleChange}/>
          </div>
          <br/>
          <div class="input-group input-group-sm">
              <input type="text" name="linkedin" class="form-control input-sm" placeholder="LinkedIn" value={this.state.linkedin}  onChange={this.handleChange}/>
          </div>
        </div>
      </div>
    </div>



  </div>

  <div class="row">

      <div class="col-md-12 col-sm-12 col-xs-12">
        
      <div class="card">   
  <div class="card-body">                    
    <div class="col-md-12">
      
<div class="form-check">
  <input class="form-check-input" type="radio" name="optiontoshow" id="optiontoshowat2" checked value="onlypartners" onChange={this.handleChange} />
  <label class="form-check-label" for="optiontoshowat2">
    Exclusive partnership is only for BeWise Partners (B2B)
  </label>
</div>
 
    </div></div> 
    </div>                        
        
        
      </div>                        

  </div>


  <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Message from BeWise Team</div>
          <div class="row">
            <div class="col-lg-3 col-sm-12">

                  { new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.notes_senttime)}
                           
            </div>
            <div class="col-lg-9 col-sm-12">

                <div class="messagebox">{this.state.notes_webmaster}</div>
                           
            </div>
            

          </div>
         
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <button type="button" class="btn btn-primary" onClick={()=>this.savefornow()}>Save</button>
      &nbsp;
      <button type="button" class="btn btn-primary" onClick={()=>this.submission()}>Submit for Approval</button>
      &nbsp;
      <button type="button" class="btn btn-primary" onClick={()=>this.showthumbnail()}>Thumbnail Preview</button>
      &nbsp;
      <button type="button" class="btn btn-primary" onClick={()=>this.showdetailed()}>Detailed Preview</button> 
    </div>
  </div>
    </React.Fragment>
}
  <Modal isOpen={this.state.thumbpreview} className="modalpopup">
          <ModalHeader>Preview</ModalHeader>
          <ModalBody className='p-0'>
              
              <div class="cardi horizontal">
                <div class="cardi-image">
                  <img src={BASEURL+"/uploads/"+this.state.logo} />
                </div>
                <div class="cardi-stacked">
                  <div class="cardi-content">
                    <h3>{this.state.name}</h3>
                    <div dangerouslySetInnerHTML={{__html:this.state.description}}></div>
                    <button class="btn btn-primary btn-sm">view more</button>
                   </div>
                 </div>
             </div>
          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop1}>Close</button>
              </div>
            </div>

          </ModalFooter>
  </Modal>

  <Modal size="lg" isOpen={this.state.detailedpreview} className="modalpopup">
          <ModalHeader>Preview - Detail Page View</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>

                <div className="row">            
                    <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding">
                        <img src={headerimage} class="headerimagewidth" /> 
                    </div>
                </div>

                <div className="row">
                      
                  <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding">
                           
                  <div class="row">
                        <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding">
                          <div class="per20 logobox">
                            <img src={IMGBASEURL+"uploads/"+this.state.logo} class="orgphoto" />
                          </div>
                        </div>
                        <div class="col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding">
                          <a href="#" target="_blank"><img src={IMGBASEURL+"uploads/"+this.state.banner} class="bannerimage" /></a>
                        </div>
                      </div> 


                      <div class="row">
                          <div class="col-lg-2 leftmenu">
                          <img src={leftmenuimage} class="leftmenuimg" />
                          </div>

                          <div class="col-lg-8">

                                <div class="onDemandInfo" id="onDemandInfo">
                                  <div id="description_section"><h3>About Us</h3>
                                  <div class="aboutinfo" dangerouslySetInnerHTML={{__html:this.state.description}}></div>
                                  </div>
                                  <br/>
                                  <div id="exclusive_offers_section">
                                    <h3>Exclusive Offers</h3>
                                      <div class="containerrow"><div>No Offers</div>
                                      </div>
                                  </div>
                                  <br/>
                                  <div id="brochure_section"><h3>Brochures/Samples</h3><div>N/A</div></div>
                                  <br/>
                                  <div id="video_section"><h3>Videos</h3>
                                  <div class="row n5v3k">
                                    <div class="container">Video not available in preview</div>
                                  </div>
                                  </div>
                                  <br/>
                                  <div id="contactinfo_section"><h3>Contact Info</h3>
                                  <div class="col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left">
                                    <div class="per100 text-left">
                                      <div class="bs_social"><div> Email Address: <b>{this.state.email}</b> </div><br/>
                                        <div> Website: <b><a target="_blank" href={this.state.website}>{this.state.website}</a></b> </div>
                                        <br/>
                                        <div> Contact Number: <b></b> </div><br/>
                                        
                                        </div>
                                        </div>
                                      </div>
                                      </div>
                                      <br/>
                                         <div id="review_section"><h3 class="review_head">Review<div class="floatright"><small class="pointer"><i class="fa fa-plus" aria-hidden="true"></i></small></div></h3>
                                          <div class="reviewinfo">
                                            <div class="col-md-12">
                                              <div class="detailBox">
                                                <div class="form-comments"><p>Click here to view Comments!...</p></div>
                                                </div>
                                                </div>
                                                </div>
                                                </div>
                                                <br/>
                                          </div>


                          </div>

                          <div class="col-lg-2 rightmenu">

                          <img src={rightmenuimage} class="rightmenuimg" />
                          </div>
                      </div>  

                    
                  </div>



                </div>

                <div class="row">
                  <div class="col-md-12 footerp">
                    <img src={previewfooter} class="headerimagewidth"/>
                  </div>
                </div>
          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop2}>Close</button>
              </div>
            </div>

          </ModalFooter>
  </Modal>


                              </div>
                            </div>
                            </div>
                            </div>
                            </div>     
                            </div>
                            <NotificationContainer/>
                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default exclusivePartnerEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveparnter/exclusivePartnerPartnerEdit.jsx